export const introductionBtn = "introduction"
export const introductionTypeQuestion = 'introduction'
export const categoryTypeQuestion = 'categories'
export const questionTypeQuestion = 'question'
export const modularOutcomeTypeQuestion = 'modularOutcomeTypeQuestion'
export const feedbackTypeQuestion = 'feedback'
export const followupAiTypeQuestion = 'aiFollowUp'
export const completedTypeQuestion = 'completed'
export const submitTypeQuestion = 'submit'
